export const backendServiceURL =
  process.env.NODE_ENV === 'development'
    ? 'https://localhost:3303/'
    : 'https://zvision.zdravservice.ru:443/';
